package com.klantenstop.web.pages.categories

import com.materialkobweb.components.toast.ToastManager
import com.klantenstop.web.data.repos.CategoryRepo
import com.klantenstop.web.utils.MVI
import com.materialkobweb.utils.ViewModel
import com.klantenstop.web.utils.catchWithCancellation
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class AllCategoriesViewModel(
    private val categoryRepo: CategoryRepo = CategoryRepo
) : ViewModel(), MVI<AllCategoriesContract.State, AllCategoriesContract.Intent, AllCategoriesContract.Effect> {

    private val _state = MutableStateFlow(AllCategoriesContract.State())
    override val state: StateFlow<AllCategoriesContract.State> = _state.asStateFlow()

    private val _effect = MutableSharedFlow<AllCategoriesContract.Effect>()
    override val effect: SharedFlow<AllCategoriesContract.Effect> = _effect.asSharedFlow()

    init {
        sendIntent(AllCategoriesContract.Intent.LoadCategories)
    }

    override fun sendIntent(intent: AllCategoriesContract.Intent) = coroutineScope.launch {
        when (intent) {
            is AllCategoriesContract.Intent.LoadCategories -> loadCategories()
        }
    }

    private suspend fun loadCategories() {
        val categories = catchWithCancellation(
            block = { categoryRepo.getCategories() },
            onError = { e ->
                ToastManager.error(
                    e.message ?: "Er is een fout opgetreden bij het laden van categorieën. Probeer het later opnieuw.",
                    title = "Laden mislukt"
                )
            }
        ) ?: emptyList()

        updateState { it.copy(categories = categories.sortedBy { category -> category.name.lowercase() }, loading = false) }
    }

    override fun emitEffect(effect: AllCategoriesContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (AllCategoriesContract.State) -> AllCategoriesContract.State) {
        _state.update(block)
    }
}
